import React from "react";

/* Form & Form Validation */
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { Divider, PageHeader, Col, Row } from "antd";
import { InputText, SelectWithSearch, InputDate, InputTextarea } from "../../../../core/components/form";

import { CloudUploadOutlined } from "@ant-design/icons";

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
};

const LoginSchema = Yup.object().shape({
    date: Yup.date().required("Cannot be blank").typeError("Must be a date"),
    notes: Yup.string().required("Cannot be blank"),
    amount: Yup.number().positive("Greater than 0").required("Cannot be blank").typeError("Must be a number"),
});
/**
 *
 */
export default class Formulario extends React.Component {
    _finalSchema = () => {
        const { paymentClient } = this.props;

        let extraSchema;
        if (paymentClient) {
            extraSchema = Yup.object().shape({
                client: Yup.object().nullable().required("Cannot be blank"),
            });
        } else {
            extraSchema = Yup.object().shape({
                vendor: Yup.object().nullable().required("Cannot be blank"),
            });
        }

        return LoginSchema.concat(extraSchema);
    };

    _goBack = () => {
        this.props.history.goBack();
    };

    _initialForm = () => {
        const { alta, data, clientId, vendorId } = this.props;

        let client = undefined;
        let vendor = undefined;

        if (clientId) {
            const e = (this.props.data.clients || []).find((item) => item.id == clientId);
            if (e) {
                client = { value: clientId, label: e.name };
            }
        }

        if (vendorId) {
            const e = (this.props.data.vendors || []).find((item) => item.id == vendorId);
            if (e) {
                vendor = { value: vendorId, label: e.name };
            }
        }

        if (!alta && data && data.timestamp) {
            return {
                client: undefined,
                vendor: undefined,
                notes: "",
                date: "",
                amount: 0,
            };
        } else {
            return {
                client: client,
                vendor: vendor,
                notes: "",
                date: "",
                amount: 0,
            };
        }
    };

    _selectClients = () => {
        return (this.props.data.clients || []).map((item) => {
            return { value: item.id.toString(), label: item.name };
        });
    };

    _selectVendors = () => {
        return (this.props.data.vendors || []).map((item) => {
            return { value: item.id.toString(), label: item.name };
        });
    };

    render() {
        const { paymentClient } = this.props;

        return (
            <>
                <Formik
                    initialValues={this._initialForm()}
                    validationSchema={this._finalSchema()}
                    onSubmit={this.props.handleSubmit}
                >
                    {({ isSubmitting, touched, errors, values }) => (
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader ghost={false} onBack={this._goBack} title="PAYMENT" subTitle="FORM">
                                <Form>
                                    <Divider orientation="left" plain>
                                        {" "}
                                        General Fields
                                    </Divider>
                                    {paymentClient ? (
                                        <SelectWithSearch
                                            name="client"
                                            label="Client"
                                            placeholder="Client"
                                            errors={errors.client}
                                            touched={touched.client}
                                            layout="horizontal"
                                            formItemLayout={formItemLayout}
                                            options={this._selectClients()}
                                            required
                                        />
                                    ) : (
                                        <SelectWithSearch
                                            name="vendor"
                                            label="Vendor"
                                            placeholder="Vendor"
                                            errors={errors.vendor}
                                            touched={touched.vendor}
                                            layout="horizontal"
                                            formItemLayout={formItemLayout}
                                            options={this._selectVendors()}
                                            required
                                        />
                                    )}
                                    <InputDate
                                        name="date"
                                        label="Date"
                                        placeholder="Date"
                                        errors={errors.date}
                                        touched={touched.date}
                                        layout="horizontal"
                                        formItemLayout={formItemLayout}
                                    />
                                    <InputTextarea
                                        name="notes"
                                        label="Notes"
                                        placeholder="Notes"
                                        errors={errors.notes}
                                        touched={touched.notes}
                                        layout="horizontal"
                                        formItemLayout={formItemLayout}
                                    />
                                    <InputText
                                        name="amount"
                                        label="Amount"
                                        placeholder=""
                                        errors={errors.amount}
                                        touched={touched.amount}
                                        layout="horizontal"
                                        formItemLayout={formItemLayout}
                                        required
                                    />

                                    <Divider />

                                    <Row>
                                        <Col span={16} offset={4}>
                                            <button
                                                onClick={this._goBack}
                                                type="button"
                                                className="ant-btn ant-btn-default"
                                            >
                                                <i className="fa fa-arrow-left"></i>
                                                <Divider type="vertical" />
                                                Cancel
                                            </button>
                                            <div className="pull-right">
                                                <button
                                                    type="submit"
                                                    className="ant-btn ant-btn-primary"
                                                    disabled={isSubmitting}
                                                >
                                                    <CloudUploadOutlined />
                                                    <Divider type="vertical" />
                                                    {isSubmitting ? "One moment ..." : "Save"}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </PageHeader>
                        </div>
                    )}
                </Formik>
            </>
        );
    }
}
